import { initElements, playVideo } from '../defs';

export default function initVideoPreview() {
    initElements('.videoPreview', async root => {
        const container = root.querySelector('.videoPreview-player');
        const modal = root.dataset.interactionType === 'modal';
        root.classList.add('is--initialized');
        const control = await playVideo(container, {
            videoId: root.dataset.id,
            provider: root.dataset.provider,
            background: !modal,
            fillSpace: root.classList.contains('size--fill'),
            modal,
        });
        const playBtns = [].slice.apply(document.querySelectorAll(`[data-video-preview-play-btn="${root.dataset.id}"]`));
        playBtns.forEach(triggerEl => {
            triggerEl.addEventListener('click', () => {
                control.play();
            });
        });
    });
}
